import { CalendarDayButton } from '@/components/ui/calendar';
import { cn } from '@/lib/utils';
import type { ComponentProps } from 'react';
import { CALENDAR_EVENT_META } from '../calendar-utils';

export const EventCalendarDayButton = ({
  children,
  modifiers,
  className,
  ...props
}: ComponentProps<typeof CalendarDayButton>) => {
  const dotClasses = [
    modifiers.personalTask ? CALENDAR_EVENT_META.personal.dotClassName : null,
    modifiers.milestoneTask ? CALENDAR_EVENT_META.milestone.dotClassName : null,
    modifiers.projectTask ? CALENDAR_EVENT_META.project.dotClassName : null,
    modifiers.invitedTask ? CALENDAR_EVENT_META.invited.dotClassName : null,
  ].filter(Boolean) as string[];

  return (
    <CalendarDayButton
      className={cn(className, dotClasses.length > 0 && 'font-medium')}
      modifiers={modifiers}
      {...props}
    >
      <span>{children}</span>
      {dotClasses.length > 0 && (
        <span className="mt-0.5 flex items-center justify-center gap-0.5">
          {dotClasses.map((dotClassName, index) => (
            <span
              key={`${dotClassName}-${index}`}
              className={cn('h-1.5 w-1.5 rounded-full', dotClassName)}
            />
          ))}
        </span>
      )}
    </CalendarDayButton>
  );
};
